<template>
  <div class="my-order" ref="container">
    <div class="header bg-color-red">
      <div class="picTxt acea-row row-between-wrapper">
        <div class="text">
          <div class="name">订单信息</div>
          <div>
            累计订单：{{ orderData.count || 0 }} 总消费：￥{{
              orderData.sumPrice || 0
            }}
          </div>
        </div>
        <div class="pictrue"><img src="@assets/images/orderTime.png" /></div>
      </div>
    </div>
    <div class="nav acea-row row-around">
      <div
        class="item"
        :class="{ on: type === 0 }"
        @click="$router.replace({ path: '/order/list/0' })"
      >
        <div>待付款</div>
        <div class="num">{{ orderData.unpaid || 0 }}</div>
      </div>
      <div
        class="item"
        :class="{ on: type === 1 }"
        @click="$router.replace({ path: '/order/list/1' })"
      >
        <div>待签字</div>
        <div class="num">{{ orderData.received || 0 }}</div>
      </div>
      <div
        class="item"
        :class="{ on: type === 2 }"
        @click="$router.replace({ path: '/order/list/2' })"
      >
        <div>待评价</div>
        <div class="num">{{ orderData.evaluated || 0 }}</div>
      </div>
      <div
        class="item"
        :class="{ on: type === 3 }"
        @click="$router.replace({ path: '/order/list/3' })"
      >
        <div>已完成</div>
        <div class="num">{{ orderData.complete || 0 }}</div>
      </div>
    </div>
    <div class="list">
      <div class="item" v-for="order in orderList" :key="order.id">
        <div class="title acea-row row-between-wrapper">
          <div class="acea-row row-middle">
            <span
              class="sign cart-color acea-row row-center-wrapper"
              v-if="order.pinkId > 0"
              >拼团</span
            >
            <span
              class="sign cart-color acea-row row-center-wrapper"
              v-if="order.seckillId > 0"
              >秒杀</span
            >
            <span
              class="sign cart-color acea-row row-center-wrapper"
              v-if="order.bargainId > 0"
              >砍价</span
            >
            {{ formatDate(order.createTime) }}
          </div>
          <div class="font-color-red">{{ getStatus(order) }}</div>
        </div>
        <div
          @click="$router.push({ path: `/order/detail/${order.id}` })"
          v-if="order.items"
        >
          <div
            class="item-info acea-row row-between row-top"
            v-for="item in order.items"
            :key="item.id"
          >
            <div class="pictrue">
              <img
                src="@assets/images/def_service.jpg"
                v-if="!item.itemPic"
                class="no-picture"
              />
              <img :src="item.itemPic + '!tmb_130'" v-else />
            </div>
            <div>
              <div class="text acea-row row-between">
                <div class="name line2">{{ item.itemName }}</div>
                <div class="money">
                  <div>￥{{ item.price }}</div>
                  <div>x{{ item.num }}</div>
                </div>
              </div>
              <div class="text acea-row row-between">
                服务顾问：{{ item.waiterName }}
              </div>
            </div>
          </div>
        </div>
        <div class="totalPrice" v-if="order.items">
          共{{ order.items.length || 0 }}个项目，总金额
          <span class="money font-color-red">￥{{ order.totalAmount }}</span>
        </div>

        <div
          @click="$router.push({ path: `/order/detail/${order.id}` })"
          v-if="order.orderType < 2 && !order.items"
        >
          <div class="item-info acea-row row-between row-top">
            <div class="pictrue">
              <img src="@assets/images/def_service.jpg" class="no-picture" />
            </div>
            <div>
              <div class="text acea-row row-between">
                <div class="name line2">现金充值{{ order.money }}元</div>
                <div class="money">
                  <div>￥{{ order.money }}</div>
                </div>
              </div>
              <div class="text acea-row row-between">
                服务顾问：{{ order.waiterName || "-" }}
              </div>
            </div>
          </div>
        </div>

        <div class="bottom acea-row row-right row-middle">
          <template v-if="order.status === 0">
            <div class="bnt cancelBnt" @click="cancelOrder(order)">
              取消订单
            </div>
            <div class="bnt bg-color-red" @click="paymentTap(order)">
              立即付款
            </div>
          </template>
          <template v-if="order.status === 1 || order.status === 9">
            <div
              class="bnt bg-color-red"
              @click="$router.push({ path: '/order/detail/' + order.id })"
            >
              查看详情
            </div>
          </template>
          <div
            class="bnt default"
            @click="$router.push({ path: `/order/sign/${order.id}` })"
            v-if="order.status == 1"
          >
            去签字
          </div>
          <div
            class="bnt bg-color-red"
            @click="$router.push({ path: `/order/comment/${order.id}` })"
            v-if="order.status == 2"
          >
            去评价
          </div>
          <template v-if="order.status === 4">
            <div
              class="bnt bg-color-red"
              @click="$router.push({ path: '/order/detail/' + order.id })"
            >
              查看订单
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="noCart" v-if="orderList.length === 0 && page > 1">
      <div class="pictrue"><img src="@assets/images/noOrder.png" /></div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
    <Payment
      v-model="pay"
      :types="payType"
      @checked="toPay"
      :balance="userInfo.money"
    ></Payment>
  </div>
</template>
<script>
import { getOrderData, getOrderList } from "@api/order";
import {
  cancelOrderHandle,
  payOrderHandle,
  takeOrderHandle,
} from "@libs/order";
import { mapGetters } from "vuex";
import { isWeixin } from "@utils";
import dayjs from "dayjs";
import Loading from "@components/Loading";
import Payment from "@components/Payment";

const STATUS = [
  "待付款",
  "待签字",
  "待评价",
  "已完成",
  "已关闭",
  "无效订单",
  "",
  "",
  "",
  "待付款",
];
const NAME = "MyOrder";

export default {
  name: NAME,
  data() {
    return {
      offlinePayStatus: 2,
      orderData: {},
      type: parseInt(this.$route.params.type) || 0,
      page: 1,
      limit: 20,
      loaded: false,
      loading: false,
      orderList: [],
      pay: false,
      payType: ["weixin", "alipay", "yue", "offline"],
      from: isWeixin() ? "weixin" : "weixinh5",
    };
  },
  watch: {
    $route: function () {
      this.changeType(parseInt(this.$route.params.type) || 0);
    },
  },
  components: {
    Loading,
    Payment,
  },
  computed: mapGetters(["userInfo"]),
  methods: {
    setOfflinePayStatus: function (status) {
      var that = this;
      that.offlinePayStatus = status;
      if (status === 1) {
        if (that.payType.indexOf("offline") < 0) {
          that.payType.push("offline");
        }
      }
    },
    getOrderData() {
      getOrderData().then((res) => {
        this.orderData = res.result;
      });
    },
    takeOrder(order) {
      takeOrderHandle(order.id).finally(() => {
        this.reload();
        this.getOrderData();
      });
    },
    reload() {
      this.changeType(this.type);
    },
    changeType(type) {
      this.type = type;
      this.orderList = [];
      this.page = 1;
      this.loaded = false;
      this.loading = false;
      this.getOrderList();
    },
    getOrderList() {
      if (this.loading || this.loaded) return;
      this.loading = true;
      const { page, limit, type } = this;
      getOrderList({ page, limit, type }).then((res) => {
        this.orderList = this.orderList.concat(res.result.records);
        this.page++;
        this.loaded = res.result.total < this.limit;
        this.loading = false;
      });
    },
    getStatus(order) {
      return STATUS[order.status];
    },
    cancelOrder(order) {
      cancelOrderHandle(order.id)
        .then(() => {
          this.orderList.splice(this.orderList.indexOf(order), 1);
        })
        .catch(() => {
          this.reload();
        });
    },
    paymentTap: function (order) {
      var that = this;
      if (!(order.pinkId > 0 || order.bargainId > 0 || order.seckillId > 0)) {
        that.setOfflinePayStatus(order.offlinePayStatus);
      }
      this.pay = true;
      this.toPay = (type) => {
        payOrderHandle(order.id, that.payType.indexOf(type), that.from)
          .then(() => {
            const type = parseInt(this.$route.params.type) || 0;
            that.changeType(type);
            that.getOrderData();
          })
          .catch((res) => {
            if (res.status === "WECHAT_H5_PAY")
              return that.$router.push({
                path: "/order/status/" + order.id + "/5",
              });
            const type = parseInt(that.$route.params.type) || 0;
            that.changeType(type);
            that.getOrderData();
          });
      };
    },
    formatDate(time) {
      return dayjs(time).format("YYYY-MM-DD HH:mm:ss");
    },
    toPay() {},
  },
  mounted() {
    this.getOrderData();
    this.getOrderList();

    this.$scroll(this.$refs.container, () => {
      !this.loading && this.getOrderList();
    });
  },
};
</script>

<style scoped>
.noCart {
  margin-top: 0.17rem;
  padding-top: 0.1rem;
}

.noCart .pictrue {
  width: 4rem;
  height: 3rem;
  margin: 0.7rem auto 0.5rem auto;
}

.noCart .pictrue img {
  width: 100%;
  height: 100%;
}
.my-order .no-picture {
  border-radius: 2px;
  border: 1px solid #c3cbd6;
}
</style>
